package org.matthewo.schema.games

import org.matthewo.math.minus
import org.matthewo.math.plus
import org.matthewo.schema.CRI_YEAR_PREFIX
import org.matthewo.schema.RankingMetrics
import org.matthewo.schema.StandardMetrics
import org.matthewo.symbolprocessor.GameSchema
import org.matthewo.symbolprocessor.Metric
import org.matthewo.symbolprocessor.Period

@GameSchema(CRI_YEAR_PREFIX + 2021, "Freight Frenzy CRI", 3)
interface MetricsFreightFrenzyCRI<T : Number> : StandardMetrics<T>, RankingMetrics<T> {
    override val tbp1 get() = auto

    @Metric(Period.AUTO, "Bonus")
    val apBonus: T

    @Metric(Period.AUTO, "Level 1")
    val apLevel1: T

    @Metric(Period.AUTO, "Level 2")
    val apLevel2: T

    @Metric(Period.AUTO, "Level 3")
    val apLevel3: T

    @Metric(Period.AUTO, "Coop")
    val apCoop: T

    @Metric(Period.AUTO, "Carousel")
    val apCarousel: T

    @Metric(Period.AUTO, "Navigation")
    val apNavigation: T

    @Metric(Period.TELEOP, "Level 1")
    val tpLevel1: T

    @Metric(Period.TELEOP, "Level 2")
    val tpLevel2: T

    @Metric(Period.TELEOP, "Level 3")
    val tpLevel3: T

    @Metric(Period.TELEOP, "Coop")
    val tpCoop: T

    @Metric(Period.TELEOP, "Shared")
    val tpShared: T

    @Metric(Period.ENDGAME, "Duck Deliver")
    val epDelivered: T

    @Metric(Period.ENDGAME, "Alliance Balance")
    val epAllianceBalance: T

    @Metric(Period.ENDGAME, "Coop Balance")
    val epCoopBalance: T

    @Metric(Period.ENDGAME, "Shared Tip")
    val epSharedTip: T

    @Metric(Period.ENDGAME, "Cap")
    val epCap: T

    @Metric(Period.ENDGAME, "Park")
    val epPark: T
}

val <T : Number> MetricsFreightFrenzyCRI<T>.alliance: T
    get() = apBonus +
            apLevel1 + apLevel2 + apLevel3 +
            tpLevel1 + tpLevel2 + tpLevel3 +
            epAllianceBalance

val <T : Number> MetricsFreightFrenzyCRI<T>.shared: T
    get() = tpShared + epSharedTip

val <T : Number> MetricsFreightFrenzyCRI<T>.coop: T
    get() = apCoop + tpCoop + epCoopBalance

fun <T : Number> MutableMetricsFreightFrenzyCRI<T>.computeTotals() {
    auto = apBonus + apLevel1 + apLevel2 + apLevel3 + apCoop + apCarousel + apNavigation
    teleop = tpLevel1 + tpLevel2 + tpLevel3 + tpCoop + tpShared
    endgame = epDelivered + epAllianceBalance + epCoopBalance + epSharedTip + epCap + epPark
    npTotal = auto + teleop + endgame
    total = npTotal - penalty
}
